import { autoserialize, autoserializeAs } from 'cerialize';
import { Reservation } from './reservation';
import { RideRequestLocation } from './ride-request-location';

export class RecoveryRide {
  @autoserializeAs(Reservation)
  reservation: Reservation;

  @autoserializeAs(RideRequestLocation)
  recoveryPickupLocation: RideRequestLocation;

  @autoserialize
  note: string;
}
